import themeSelectors from "./constants/selectors-map";
import EVENTS from "./constants/events-map";
import initEmitter from "./prestashop";
import initResponsiveToggler from "./responsive-toggler";
import initQuickview from "./quickview";
import initCart from "./pages/cart";
import initCheckout from "./pages/checkout";
import initCustomer from "./pages/customer";
import initProductBehavior from "./product";
import initMobileMenu from "./mobile-menu";
import initSearchbar from "./modules/ps_searchbar";
import initLanguageSelector from "./modules/ps_languageselector";
import initCurrencySelector from "./modules/ps_currencyselector";
import initVisiblePassword from "./visible-password";
import initErrorHandler from "./errors";
import useToast from "./components/useToast";
import useAlert from "./components/useAlert";
import usePasswordPolicy from "./components/usePasswordPolicy";
import useProgressRing from "./components/useProgressRing";
import useQuantityInput from "./components/useQuantityInput";
import "./modules/blockcart";
import "./modules/facetedsearch";
import initDesktopMenu from "./modules/ps_mainmenu";
import initFormValidation from "./form-validation";
import initFormFields from "./form-fields";
import usePopovers from "./components/usePopovers";
import initSelect2 from "./select2";
import initSlickJs from "@js/slickjs";
import initIsotopeJs from "./isotope";
import accordionsClosed from "./accordions";
initEmitter();
$(() => {
  const { prestashop, Theme: { events: events2 } } = window;
  initProductBehavior();
  initQuickview();
  initCheckout();
  initCustomer();
  initResponsiveToggler();
  initCart();
  useQuantityInput();
  initSearchbar();
  initLanguageSelector();
  initCurrencySelector();
  initMobileMenu();
  initVisiblePassword();
  initDesktopMenu();
  initFormValidation();
  initFormFields();
  initErrorHandler();
  usePasswordPolicy(".field-password-policy");
  usePopovers();
  initSelect2();
  initSlickJs();
  initIsotopeJs();
  accordionsClosed();
  prestashop.on(events2.responsiveUpdate, () => {
    initSearchbar();
    initLanguageSelector();
    initCurrencySelector();
    initDesktopMenu();
  });
  $(window).on("elementor/frontend/init", () => {
    usePopovers();
    initSelect2();
    initSlickJs();
    initIsotopeJs();
  });
});
export const components = {
  useToast,
  useAlert,
  useProgressRing,
  useQuantityInput,
  usePopovers,
  initVisiblePassword,
  initFormFields,
  initSelect2,
  initSlickJs,
  initIsotopeJs,
  accordionsClosed
};
export const selectors = themeSelectors;
export const events = EVENTS;
export default {
  initProductBehavior,
  initQuickview,
  initCheckout,
  initResponsiveToggler,
  initCart,
  useQuantityInput,
  initSearchbar,
  initLanguageSelector,
  initCurrencySelector,
  initMobileMenu,
  initVisiblePassword,
  initDesktopMenu,
  initSelect2,
  initSlickJs,
  initIsotopeJs,
  accordionsClosed
};
